import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { N1EventsEdit } from "./edit";
import { N1EventsNew } from "./new";
import { N1EventsTable } from "./table";

export default function N1Events() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Events");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<N1EventsEdit />} />
      <Route index element={<N1EventsTable />} />
      <Route path="/new" element={<N1EventsNew />} />
    </Routes>
  );
}
